import useSWR from "swr";
import { useServicesContext } from "../../providers/ServicesProvider";
import { useMemo } from "react";
import { ALL_PAGES_SIZE, GROUP_TYPES, PROPERTY_KEYS, SWR_KEY_PREFIX } from "../../constants/constants";

export const useUserTeams = ({
    organizationId,
    email,
    skip,
    groupTypes
}: {
    organizationId?: string;
    email?: string;
    skip?: boolean;
    groupTypes?: GROUP_TYPES[];
}) => {
    const { teamsService } = useServicesContext();

    const normalizedGroupTypes = useMemo(
        () => Array.from(new Set(groupTypes && groupTypes.length > 0 ? groupTypes : [GROUP_TYPES.CUSTOM])).sort(),
        [groupTypes]
    );

    const key = useMemo(() => {
        if (!organizationId || !email || skip) return null;
        const searchParams = new URLSearchParams(`properties[0].Name=${PROPERTY_KEYS.TEAM}&properties[0].Value=true`);
        searchParams.set("organizationId", organizationId);
        searchParams.append("users", email);
        normalizedGroupTypes.forEach((groupType) => {
            searchParams.append("groupTypes", groupType);
        });
        return `${SWR_KEY_PREFIX.TEAMS}:/api/usergroups?${searchParams.toString()}`;
    }, [organizationId, email, skip, normalizedGroupTypes]);

    const { data, isValidating, error } = useSWR(key, () => {
        return teamsService!.getTeams({
            organizationId: organizationId!,
            emails: [email!],
            groupTypes: normalizedGroupTypes,
            size: ALL_PAGES_SIZE
        });
    });

    return {
        teams: data?.items || [],
        totalCount: data?.totalCount ?? 0,
        loading: isValidating,
        error
    };
};
